'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const invert$1 = require('../../object/invert.js');

function invert(obj) {
    return invert$1.invert(obj);
}

exports.invert = invert;
